export const arrow = () => {
  var acc = document.getElementsByClassName("arrow")
  var i

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      document.documentElement.scrollTop = window.innerHeight
    });
  }
}
